import { render, staticRenderFns } from "./ProductMain.vue?vue&type=template&id=0856565c&scoped=true&"
import script from "./ProductMain.vue?vue&type=script&lang=js&"
export * from "./ProductMain.vue?vue&type=script&lang=js&"
import style0 from "./ProductMain.vue?vue&type=style&index=0&id=0856565c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0856565c",
  null
  
)

export default component.exports